__turbopack_context__.v({
  "PrivacyProvideCouponSheet": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__PrivacyProvideCouponSheet",
  "buttonContent": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__buttonContent",
  "closeButton": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__closeButton",
  "confirmButton": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__confirmButton",
  "container": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__container",
  "content": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__content",
  "contentShow": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__contentShow",
  "description": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__description",
  "link": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__link",
  "overlay": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__overlay",
  "overlayShow": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__overlayShow",
  "table": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__table",
  "tableCell": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__tableCell",
  "tdCell": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__tdCell",
  "titleContent": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__titleContent",
  "wrap": "CouponPrivacyProvideModal-module-scss-module__uv-PMG__wrap",
});
